module.exports = __webpack_public_path__ + "static/img/4578_phase_function_Paper_Points.cb25977.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4578_phase_function_Paper_Points.png
// module id = a784
// module chunks = 0